import { render } from "./tickets.vue?vue&type=template&id=24269074&scoped=true"
import script from "./tickets.vue?vue&type=script&lang=js"
export * from "./tickets.vue?vue&type=script&lang=js"

import "./tickets.vue?vue&type=style&index=0&id=24269074&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24269074"]])

export default __exports__